import * as React from 'react';

import './styles.scss';

const Loader: React.FC = () => (
  <div className="loader">
    <div className="loading-bars">
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
    </div>
  </div>
);

export default Loader;
